import { render } from "./FasceDiRicavo.vue?vue&type=template&id=20df39d7&ts=true"
import script from "./FasceDiRicavo.vue?vue&type=script&lang=ts"
export * from "./FasceDiRicavo.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__